import React from "react";

const NotFound = () => {
  return <h1>NotFound Page</h1>;
};
export default NotFound;
